import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "display_modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Butiran Permohonan", -1)
const _hoisted_6 = {
  id: "kt_customers_export_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { class: "col-lg-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-3 text-gray-800 text-hover-primary" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Diri")
], -1)
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "row mt-3 h-40px" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "No. Kad Pengenalan Baharu:")
], -1)
const _hoisted_15 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_16 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_18 = { class: "row h-40px" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nama Penuh:")
], -1)
const _hoisted_20 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_21 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_23 = { class: "d-flex justify-content-between flex-column mb-3" }
const _hoisted_24 = { class: "row h-40px" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "No. Telefon Bimbit:", -1)
const _hoisted_26 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_27 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_29 = { class: "row h-40px" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, "E-mel:", -1)
const _hoisted_31 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_32 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_34 = { class: "row h-40px" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Jantina:", -1)
const _hoisted_36 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_37 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_39 = { class: "col-lg-12" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "fs-3 text-gray-800 text-hover-primary" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Perkhidmatan")
], -1)
const _hoisted_41 = { class: "d-flex flex-column" }
const _hoisted_42 = { class: "row mt-3 h-40px" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Jawatan:")
], -1)
const _hoisted_44 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_45 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_47 = { class: "row h-40px" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tarikh Lantikan Ke Perkhidmatan Sekarang:")
], -1)
const _hoisted_49 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_50 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_52 = { class: "d-flex justify-content-between flex-column mb-3" }
const _hoisted_53 = { class: "row h-40px" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Kod Agensi:", -1)
const _hoisted_55 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_56 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_58 = { class: "row h-40px" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, "Nama Ketua Jabatan:", -1)
const _hoisted_60 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_61 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_63 = { class: "row h-40px" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, "E-mel Ketua Jabatan:", -1)
const _hoisted_65 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_66 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_68 = { class: "row h-40px" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Jawatan Ketua Jabatan:", -1)
const _hoisted_70 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_71 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_73 = { class: "row h-40px" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Calon Tumpang:", -1)
const _hoisted_75 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_76 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_78 = { class: "row h-40px" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Kementerian:", -1)
const _hoisted_80 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_81 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_83 = { class: "row h-40px" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Nama & Alamat Pejabat:", -1)
const _hoisted_85 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_86 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_88 = { class: "row h-40px" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Negeri:", -1)
const _hoisted_90 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_91 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_93 = { class: "row h-40px" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Poskod:", -1)
const _hoisted_95 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_96 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_98 = { class: "row h-40px" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Telefon Pejabat:", -1)
const _hoisted_100 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_101 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_103 = { class: "row h-40px" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Faks:", -1)
const _hoisted_105 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_106 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_108 = { class: "row" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Taraf Pendidikan:", -1)
const _hoisted_110 = { class: "col-lg-8 d-flex flex-column" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_112 = { class: "col-lg-12" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "fs-3 text-gray-800 text-hover-primary" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Peperiksaan Yang Dimohon")
], -1)
const _hoisted_114 = { class: "d-flex flex-column" }
const _hoisted_115 = { class: "row mt-3 h-40px" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Kod Dan Nama Peperiksaan:")
], -1)
const _hoisted_117 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_118 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_120 = { class: "row h-40px" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Pusat Peperiksaan Dipilih:")
], -1)
const _hoisted_122 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_123 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_125 = { class: "d-flex justify-content-between flex-column mb-3" }
const _hoisted_126 = { class: "row h-40px" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Status Menduduki:", -1)
const _hoisted_128 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_129 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_131 = { class: "row h-40px" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, "Butiran Calon Orang Kurang Upaya (OKU):", -1)
const _hoisted_133 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_134 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.permohonan.no_kad_pengenalan), 1)
                  ])
                ]),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.permohonan.nama), 1)
                  ])
                ])
              ]),
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.permohonan.no_telefon), 1)
                  ])
                ]),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.permohonan.emel), 1)
                  ])
                ]),
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.permohonan.jantina ? _ctx.permohonan.jantina == "Lelaki" || "L" ? "Lelaki" : "Perempuan" : "-"), 1)
                  ])
                ]),
                _hoisted_38
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.permohonan.jawatan_sekarang), 1)
                  ])
                ]),
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.formatDate(_ctx.permohonan.tarikh_lantikan_perkhidmatan)), 1)
                  ])
                ])
              ]),
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.permohonan.kod_agensi ?? "-") + " - " + _toDisplayString(_ctx.permohonan.jenis_jabatan?.nama_jenis ?? "-"), 1)
                  ])
                ]),
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.permohonan.ketua_jabatan_nama), 1)
                  ])
                ]),
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.permohonan.ketua_jabatan_emel), 1)
                  ])
                ]),
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.permohonan.ketua_jabatan_jawatan), 1)
                  ])
                ]),
                _hoisted_72,
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.permohonan.is_calon_tumpang), 1)
                  ])
                ]),
                _hoisted_77,
                _createElementVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.permohonan.kementerian?.nama_kementerian ?? "-"), 1)
                  ])
                ]),
                _hoisted_82,
                _createElementVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.permohonan.pejabat_alamat), 1)
                  ])
                ]),
                _hoisted_87,
                _createElementVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.permohonan.pejabat_negeri?.nama_negeri ?? "-"), 1)
                  ])
                ]),
                _hoisted_92,
                _createElementVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.permohonan.pejabat_poskod), 1)
                  ])
                ]),
                _hoisted_97,
                _createElementVNode("div", _hoisted_98, [
                  _hoisted_99,
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.permohonan.pejabat_no_telefon), 1)
                  ])
                ]),
                _hoisted_102,
                _createElementVNode("div", _hoisted_103, [
                  _hoisted_104,
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.permohonan.pejabat_no_fax), 1)
                  ])
                ]),
                _hoisted_107,
                _createElementVNode("div", _hoisted_108, [
                  _hoisted_109,
                  _createElementVNode("div", _hoisted_110, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permohonan.taraf_pendidikan, (pendidikan) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: pendidikan,
                        class: "fw-bolder fs-6 text-dark"
                      }, _toDisplayString(pendidikan.taraf) + " " + _toDisplayString(pendidikan.nama_bidang) + " di " + _toDisplayString(pendidikan.institusi), 1))
                    }), 128))
                  ])
                ]),
                _hoisted_111
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              _hoisted_113,
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _hoisted_116,
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.permohonan.peperiksaan?.tajuk_peperiksaan ?? "-"), 1)
                  ])
                ]),
                _hoisted_119,
                _createElementVNode("div", _hoisted_120, [
                  _hoisted_121,
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.permohonan.pusat_peperiksaan?.nama_pusat ?? "-"), 1)
                  ])
                ])
              ]),
              _hoisted_124,
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _hoisted_127,
                  _createElementVNode("div", _hoisted_128, [
                    _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.permohonan.status_menduduki ?? "-") + " " + _toDisplayString(_ctx.permohonan.tahun_menduduk_sebelum?.join(',') ?? " "), 1)
                  ])
                ]),
                _hoisted_130,
                _createElementVNode("div", _hoisted_131, [
                  _hoisted_132,
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.permohonan.is_oku) + " " + _toDisplayString(_ctx.permohonan.catatan_oku ?? " "), 1)
                  ])
                ]),
                _hoisted_135
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}